<template>
  <cc-container>
    <cc-header-nav title="区域经销" class="header">
      <template slot="right">
        <div class="search-wrap" @click.stop="openSearch">
          <cc-svg-icon icon-class="search" class-name="search-icon"></cc-svg-icon>
        </div>
        <div class="ellipsis">
          <van-icon
            class="ellipsis-icon"
            name="ellipsis"
            @click.stop="isShowSmallNav = !isShowSmallNav"
          />
        </div>
      </template>
    </cc-header-nav>
    <cc-main class="main" :style="{background:`#${ad && ad.background_color}`}">
      <cc-pull-refresh  v-model="isLoading" @refresh="onRefresh">

      <div class="banner" @click="toPage(ad)" >
        <img
          :src="(ad && ad.image) || require(`@/assets/img/regional_distributor.jpg`)"
          v-errorImg="require(`@/assets/img/regional_distributor.jpg`)"
          alt
        />
      </div>
      <not-goods v-if="list.length === 0 && m_loading === false"></not-goods>
      <van-list
        v-else
        class="goods-list"
        @click.stop
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <GoodsItem v-for="(item,index) in list" :key="index"  :item="item">
        </GoodsItem>
      </van-list>
      </cc-pull-refresh>
    </cc-main>
    <cc-small-nav v-model="isShowSmallNav" />
    <search-overlay
      :show="showSearch"
      @cacel="showSearch=false"
    >
    </search-overlay>
  </cc-container>
</template>
<script>
import GoodsItem from './item'
import { loadCtrlmarketingList } from '../../../fetch/home/regionsell'
import CartStepMixin from '@/mixins/cartStep'
import SearchOverlay from './search-overlay'

import CommandMixin from '@/mixins/command'
import ListMixin from '@/mixins/list'
import NotGoods from '../components/not-goods'

import Vue from 'vue'
import { Icon, List } from 'vant'

Vue.use(Icon)
  .use(List)
export default {
  mixins: [ListMixin, CartStepMixin, CommandMixin],
  data () {
    return {
      isLoading: false,
      isShowSmallNav: false,
      ad: {},
      list: [],
      showSearch: false
    }
  },
  components: {
    NotGoods,
    GoodsItem,
    SearchOverlay
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData (reset) {
      this.mRequest()
      const params = {
        page: this.m_page.curr,
        page_size: this.m_page.limit
      }
      let res = await loadCtrlmarketingList(params)
      this.$tips(res, {
        tip: false
      }, res => {
        this.isLoading = false
        const data = res
        this.ad = data.ad
        if (data.goods_arr.length === 0) {
          if (reset) {
            this.list = []
          }
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          this.list = reset ? data.goods_arr : [...this.list, ...data.goods_arr]
          this.addGoodField(this.list)
        }
      })
      this.mSuccess()
    },
    onRefresh () {
      this.mReset()
      this.loadData(true)
    },
    openSearch () {
      this.showSearch = true
      this.isShowSmallNav = false
    },
    toPage (ad) {
      if (ad) {
        location.href = ad.url
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  /deep/ {
    background: #ffffff !important;
    color: #333333 !important;
    .left-arrow {
      color: #333333 !important;
    }
  }
  .search-wrap {
    width: 24px;
    transform: translateX(-5px);
  }
  .search-icon {
    color: #333333;
  }
  .ellipsis {
    width: 50%;
    height: 100%;
    @include center();
    transform: translateX(-5px);
    &-icon {
      transform: rotate(90deg);
    }
  }
}
.goods-list {
  padding: 10px;
}
.banner {
  img {
    width: 375px;
    height: 130px;
  }
}
</style>
